import React, { useState } from "react";
import styles from "./HistoryTable.module.scss";
import TextButton from "../../../../common/TextButton/TextButton";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../../utils/dateFormatter";
import { countryCodeMappings } from "../../../../../constants/dataConstants";
import { useAppSelector } from "../../../../../redux/hooks";
import { convertUrlsToLinks } from "../../../../../utils/common";
import HTMLtoText from "../../../../common/HTMLToText/HTMLToText";
import { OUTCOMES } from "../../Goals/AddGoalModal/AddGoalModal";
import { getGoalStatusLabel } from "../../../../../utils/goalUtil";

interface HistoryTableProps {
  data: HistoryItem[];
  handleGoalHistoryClick: (goalHistory: HistoryItem) => void
}

const HistoryTable: React.FC<HistoryTableProps> = ({ data, handleGoalHistoryClick }) => {
  const rowLimit = 5;
  const { t } = useTranslation();
  const [isViewMore, setViewMore] = useState(false);
  const visibleData = isViewMore ? data : data.slice(0, rowLimit);
  const userDetails = useAppSelector((state: any) => state.userDetails?.user);
  const userAffiliateCode = userDetails?.userAffiliateCode || "US";
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const getOutComeType = (code: number) => OUTCOMES.find((outcome: any) => +outcome.code === code);
  return (
    <div className={styles.tbl_container}>
      <div className={styles.tbl_wrapper}>
        <div className={styles.flex_table}>
          {/* Header */}
          <div className={styles.tbl_header}>
            <div className={styles.tbl_header_cell}>{t("title")}</div>
            <div className={styles.tbl_header_cell}>{t("description")}</div>
            <div className={styles.tbl_header_cell}>{t("outcome")}</div>
            <div className={styles.tbl_header_cell}>{t("status")}</div>
          </div>

          {/* Rows */}
          {visibleData.map((item) => (
            <div
              key={item?.aboGoalId}
              className={styles.tbl_row}
              style={{
                background: currentTheme === "light" ? "#fff" : "#282828",
                border: currentTheme === "light" ? "1px solid #E4E4E4" : "",
              }}
            >
              <div className={`${styles.tbl_cell_data} ${styles.info_cell}`}>
                <label
                  htmlFor={`goal-title-${item?.aboGoalId}`}
                  className={styles.goal_title}
                  onClick={() => handleGoalHistoryClick(item)}
                >
                  {item.title}
                </label>
                <span className={styles.goal_details}>
                  {t("archived")}{" "}
                  {formatDate(
                    item?.audit?.updatedDate,
                    countryCodeMappings[userAffiliateCode] || "US",
                    "long"
                  )}
                </span>
              </div>

              <div className={`${styles.tbl_cell_data} ${styles.description}`}>
              <HTMLtoText
                  htmlContent={convertUrlsToLinks(
                    item?.note || "",
                    currentTheme
                  )}
                  alternateMessage=""
              />
              </div>

              <div className={styles.tbl_cell_data}>
                {getOutComeType(item?.outcomeType)?.value}
                <span className={styles.actions_count}>
                  {item?.goalActions?.length}{" "}
                  {item?.goalActions?.length === 1 ? t("action") : t("actions")}
                </span>
              </div>

              <div className={styles.tbl_cell_data}> {getGoalStatusLabel(item?.status)}</div>
            </div>
          ))}
        </div>
      </div>

      {rowLimit && data.length > rowLimit && (
        <div className={styles.viewmore_Section}>
          <TextButton
            label={isViewMore ? t("view_less") : t("view_more")}
            onClick={() => setViewMore(!isViewMore)}
          />
        </div>
      )}
    </div>
  );
};

export default HistoryTable;
